import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=cd17bde6&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./../assets/css/LoginRegist.css?vue&type=style&index=0&id=cd17bde6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd17bde6",
  null
  
)

export default component.exports